import { render } from "./RankingView.vue?vue&type=template&id=3d5cc832&scoped=true"
import script from "./RankingView.vue?vue&type=script&lang=js"
export * from "./RankingView.vue?vue&type=script&lang=js"

import "./RankingView.vue?vue&type=style&index=0&id=3d5cc832&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5cc832"]])

export default __exports__